import { Pipe, PipeTransform } from '@angular/core';
import type { AppLocale } from '../../services/locale/locale.service';
import { localizedDescription } from '../../utils/locale.utils';

/**
 * The `description` / `description_da` pair, in the UI language. Pure: pass the locale signal's
 * value so the pipe re-runs on a language switch.
 *
 * Usage: `sub | localizedDescription: locale()`
 */
@Pipe({ name: 'localizedDescription' })
export class LocalizedDescriptionPipe implements PipeTransform {
  transform(
    item: { description?: string | null; description_da?: string | null } | null | undefined,
    locale: AppLocale | string
  ): string {
    return item ? localizedDescription(item, locale) : '';
  }
}
